'use client';

import { useTranslation } from 'react-i18next';

/**
 * Hero heading in the "Generation Studio" / "Daily Challenges" style: the
 * lead words render white and the final word gets the pink gradient. Splitting
 * on the last space keeps it working across every locale without needing a
 * separate per-language accent key.
 */
export function GradientTitle({
  i18nKey,
  className,
}: {
  i18nKey: string;
  className?: string;
}) {
  const { t } = useTranslation('common');
  const text = t(i18nKey);
  const lastSpace = text.lastIndexOf(' ');
  const lead = lastSpace === -1 ? '' : text.slice(0, lastSpace);
  const accent = lastSpace === -1 ? text : text.slice(lastSpace + 1);

  return (
    <span className={className}>
      {lead ? <span className="text-white">{lead} </span> : null}
      <span className="bg-gradient-to-b from-pink-300 to-pink-500 bg-clip-text text-transparent">
        {accent}
      </span>
    </span>
  );
}
